<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="partnumber">PART ONE</h2>
<h2 class="parttitle"><b>POLITICS OF PUBLISHING, PEDAGOGY, AND READERSHIP</b></h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?67226884